import React from "react"
import { useFormikContext } from "formik"
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Stack,
  TextField,
  Typography,
} from "@mui/material"

const sx = {
  textareaLabel: {
    display: "block",
    fontSize: 14,
    color: "#757575",
    fontWeight: 400,
    mb: "12px",
    lineHeight: 1.4,
  },
  optionalSuffix: {
    color: "text.disabled",
    ml: "6px",
    fontSize: 14,
  },
  checkboxLabel: {
    "& .MuiFormControlLabel-label": { fontSize: 16 },
  },
}

const NotesSection = () => {
  const { values, errors, touched, handleChange, setFieldValue } = useFormikContext()

  return (
    <Stack spacing={3}>
      <Box>
        <Typography sx={sx.textareaLabel}>
          Notes packaging
          <Box component="span" sx={sx.optionalSuffix}>(optionnel)</Box>
        </Typography>
        <TextField
          name="packagingNotes"
          value={values.packagingNotes}
          onChange={handleChange}
          error={touched.packagingNotes && !!errors.packagingNotes}
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          placeholder="Ex : barquette client, fourreau, cartons, pas de plastique…"
          inputProps={{ maxLength: 1000 }}
        />
        {touched.packagingNotes && errors.packagingNotes && (
          <FormHelperText error>{errors.packagingNotes}</FormHelperText>
        )}
      </Box>
      <Box>
        <Typography sx={sx.textareaLabel}>
          Contraintes de carte
          <Box component="span" sx={sx.optionalSuffix}>(optionnel)</Box>
        </Typography>
        <TextField
          name="cardDesignNotes"
          value={values.cardDesignNotes}
          onChange={handleChange}
          error={touched.cardDesignNotes && !!errors.cardDesignNotes}
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          placeholder="Ex : jamais de porc, plats froids uniquement"
          inputProps={{ maxLength: 1000 }}
        />
        {touched.cardDesignNotes && errors.cardDesignNotes && (
          <FormHelperText error>{errors.cardDesignNotes}</FormHelperText>
        )}
      </Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={values.requiresValidation}
            onChange={(e) => setFieldValue("requiresValidation", e.target.checked)}
          />
        }
        label="Validation requise par le client"
        sx={sx.checkboxLabel}
      />
    </Stack>
  )
}

export default NotesSection
